module.exports = __webpack_public_path__ + "img/undo.643db1ef.svg";